module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"th":{"page.title":"Ticket ที่อยู่ระหว่างการดำเนินการ","page.description":"รายการของ Ticket ที่อยุ่ระหว่างการดำเนินการ"}}')
  delete Component.options._Ctor
}
